import fa from './fa';

export function t(key) {
  const parts = String(key).split('.');
  let cur = fa;
  for (let i = 0; i < parts.length; i += 1) {
    if (cur == null || typeof cur !== 'object') {
      return key;
    }
    cur = cur[parts[i]];
  }
  if (typeof cur !== 'string') {
    return key;
  }
  return cur;
}
